import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectStatus } from '../../customComponents/SelectStatus';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';


export const initObject = {
  id: undefined,
  title: "",
  code: "",
  categoryId: 0,
  categoryTitle: "",
  seatCount: 0,
  floorId: 0,
  floorTitle: "",
  isDeleted: false
};


export const columns = [
  {
    dataField: "title",
    text: "عنوان اتاق",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "floorTitle",
    text: "طبقه",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "seatCount",
    text: "تعداد تخت",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "isDeleted",
    text: "وضعیت",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },
  // {
  //   dataField: "action",
  //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
  //   // text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان اتاق",
        label: "عنوان اتاق",
        rowIdx: 1,
        class: "col-lg-4"
      },
      {
        name: "code",
        type: "text",
        component: Input,
        placeholder: "کد",
        label: "کد",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "categoryId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/category"
          reduxState="roomCategories"
          sname="categoryId"
          label="کاربری" {...props} />,
        placeholder: "کاربری",
        label: "کاربری",
        rowIdx: 3,
        class: "col-lg-4"
      },
      {
        name: "seatCount",
        type: "number",
        component: Input,
        placeholder: "تعداد تخت",
        label: "تعداد تخت",
        rowIdx: 4,
        class: "col-lg-4"
      },
      // {
      //   name: "floorId",
      //   type: "text",
      //   component: (props) =>
      //     <SelectObjectsField api="api/floor"
      //       reduxState="floors"
      //       sname="floorId"
      //       label="طبقه" {...props} />,
      //   placeholder:"طبقه",
      //   label:"طبقه",
      //   rowIdx: 3,
      //   class: "col-lg-4"
      // },

    ]
  },
  // {
  //   row: 2,
  //   list: [
  //     {
  //       name: "categoryId",
  //       type: "text",
  //       component: (props) => <SelectObjectsField api="api/category"
  //         reduxState="buildingCategories"
  //         sname="categoryId"
  //         label="کاربری" {...props} />,
  //       placeholder: "کاربری",
  //       label: "کاربری",
  //       rowIdx: 4,
  //       class: "col-lg-4"
  //     },
  //   ]
  // },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];


export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};
export const filterFields = [
  // {
  //   name: "floorId",
  //   lable: "طبقه",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/floor"
  //       reduxState="floors"
  //       sname="floorId"
  //       {...props} />
  // },
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  // {
  //   name: "categoryId",
  //   lable: "کاربری",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/category"
  //       reduxState="buildingCategories"
  //       sname="categoryId"
  //       {...props} />
  // },

  // {
  //   name: "searchText",
  //   lable: "MODULES.GENERAL.SEARCH",
  //   type: "text",
  //   list:[],
  // },

];


export const prepareFilter = (queryParams, values) => {

  const { isDeleted, floorId } = values;
  // const { isDeleted, searchText, categoryId, floorId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // // Filter by categoryId
  // filter.categoryId = categoryId !== "" ? +categoryId : 0;

  // Filter by floorId
  filter.floorId = floorId !== "" ? +floorId : 0;

  // // Filter by all fields
  // filter.title = searchText;
  // if (searchText) {
  //   filter.title = searchText;
  // }

  newQueryParams.filter = filter;

  // let whereClause = "title.contains(@0)"
  // const whereClauseParameters = [];
  // whereClauseParameters.push(searchText)

  let whereClause = ""
  const whereClauseParameters = [];
  var idx = 0;

  if (filter.floorId > 0 && idx === 0) {
    whereClause = `floorId=@${idx}`
    whereClauseParameters.push(filter.floorId)
    idx++;
  }
  else if (filter.floorId > 0 && idx > 0) {
    whereClause = whereClause + ` and floorId=@${idx}`
    whereClauseParameters.push(filter.floorId)
    idx++;
  }

  if (filter.isDeleted !== undefined && idx === 0) {
    whereClause = "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  else if (filter.isDeleted !== undefined && idx > 0) {
    whereClause = whereClause + ` and isDeleted=@${idx}`
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;


  // let wSelect = ""
  // const wParametersSelect = [];
  // if (filter.categoryId > 0) {
  //   wSelect = wSelect + "categoryId=@0"
  //   wParametersSelect.push(filter.categoryId)
  // }
  // else {
  //   wSelect = wSelect + "categoryId!=@0"
  //   wParametersSelect.push(0)
  // }
  // newQueryParams.whereClauseSelect = wSelect;
  // newQueryParams.whereClauseParametersSelect = wParametersSelect;

  return newQueryParams;
};



// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  categoryId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  floorId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  // floorId : Yup.object()
  //           .shape({
  //             id: Yup.number()
  //           .required('floorId is required'),
  //         })

});

